<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as qconst from '../vendor/qconstants'


export default {
  name: "GlobalsLifecycle",
  data() {
    return {}
  },
  computed: {},
  created() {

    // setTimeout(() => {
    //     console.log('push: debug lazyRequestPush...');
    //     this.lazyRequestPush();
    // }, 4000);

    ebus.$on('loadGlobals', () => {
      this.loadGlobals();
    });


  },
  beforeMount() {
    this.loadGlobals();
  },
  mounted() {
  },
  methods: {

    async loadGlobals() {
      let msg = {
        action: qconst.action$LoadDocs,
        collectionName: 'globals',
        query: {
          type: 'singleton',
        }
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.docs && Array.isArray(data.docs)) {
          let docs = data.docs;
          if (docs.length > 0) {
            store.commit('globals', docs[0]);
          }
        }
      }, (err) => {
      });
    },

  }// eof methods
}
</script>

<style scoped>

</style>
